import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { DtoSimulationsGetReq } from "./abst/DtoSimulationsGetReq";
import { DtoApiPager } from "./abst/DtoApiPager";

export class DtoSimulationsGetReqImple extends DtoSimulationsGetReq {
  public pager = new DtoApiPager();

  //検索条件
  //-------------------
  /**
   * ステータス
   */
  public migrationsettings: string | null = null;
  /**
   * 未入力フラグ
   * 1なら未入力指定
   */
  public setting4IsNotInput: Number | null = null;
  /**
   * 営業担当
   */
  public staffs: string | null = null;
  /**
   * 拠点
   */
  public branchs: string | null = null;
  /**
   * 年度
   */
  public businessyear: Number | null = null;

  public IsValidImple(chkPager: boolean): string[] {
    let res: string[] = new Array();
    //ページャー用入力値チェック
    if (chkPager) {
      this.pager.IsValid4Pager(res);
    } else {
      res = res.concat(super.IsValid());
    }

    return res;
  }
}
